import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import {
  Card,
  Box,
  Typography,
  Button,
  CircularProgress,
  Chip,
  Divider,
  Stack,
  Avatar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import StoreIcon from "@mui/icons-material/Store";
import { API_ENDPOINTS } from "../../../config/api";

const API_URL = API_ENDPOINTS.BRANDS.BASE;

const BrandDetailsContent = () => {
  const { id } = useParams();
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchbrand();
  }, []);

  const fetchbrand = async () => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      setBrand(response.data.brand);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching brand details:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />;
  }

  if (!brand) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>
        Brand not found
      </Typography>
    );
  }

  return (
    <Box component="section" sx={{ p: { xs: 1, sm: 3 } }}>
      <Card
        sx={{
          boxShadow: 4,
          borderRadius: "16px",
          p: { xs: 2, sm: 4 },
          maxWidth: 600,
          margin: "auto",
          mt: 5,
          background: "linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
          <Avatar sx={{ bgcolor: "primary.main", width: 48, height: 48 }}>
            <StoreIcon fontSize="large" />
          </Avatar>
          <Typography variant="h4" sx={{ fontWeight: "bold", flexGrow: 1 }}>
            Brand Details
          </Typography>
          <Link to="/brands" style={{ textDecoration: "none" }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{ borderRadius: 2, fontWeight: 500 }}
            >
              Back
            </Button>
          </Link>
        </Stack>
        <Divider sx={{ mb: 3 }} />
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            Name
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, letterSpacing: 0.5 }}>
            {brand.name}
          </Typography>
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            Logo
          </Typography>
          {brand.logo ? (
            <img
              src={brand.logo}
              alt={brand.name}
              style={{ width: 75, height: 75, objectFit: 'cover', borderRadius: 8, border: '1px solid #eee', background: '#fafafa' }}
            />
          ) : (
            <Typography variant="body2" color="text.secondary">No logo available</Typography>
          )}
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            Publish Status
          </Typography>
          <Chip
            icon={
              brand.publish ? (
                <CheckCircleIcon style={{ color: "#fff" }} />
              ) : (
                <CancelIcon style={{ color: "#fff" }} />
              )
            }
            label={brand.publish ? "Published" : "Unpublished"}
            color={brand.publish ? "success" : "default"}
            size="medium"
            sx={{
              fontWeight: 500,
              fontSize: 16,
              px: 2,
              py: 0.5,
              color: "#fff",
              borderRadius: 2,
              ...(brand.publish ? {} : { backgroundColor: '#e53935' }),
            }}
          />
        </Box>
        {/* Future extensibility: add more fields here */}
      </Card>
    </Box>
  );
};

export default BrandDetailsContent;
